import type {
    IChartProperty,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/property-modules.interface';
import type { ISubChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';
import type { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';

/**
 * 2.0 3.0版本混合时保留两种类型，下线2.0时移除V2
 */
export type ChartModel = IChartModel;
export type SubChartModel = ISubChartModel;

type PropertyModuleName = keyof IChartProperty;
/**
 * 图表上下文，用于在从Model => Config过程中，对上层数据的获取
 * 抽出Context的原因：
 *      1. ChartConfigHelper自身的属性过于冗余，造成了configHelper本身难以维护的问题
 *      所以把一些来自上层、并且不必要挂载在ChartConfigHelper实例上的数据放进Context
 *      2. 进行细粒度模块的拆分，这些模块可能有访问上层属性的诉求。从context可以方便访问，不需要逐层上层属性
 */
export class ChartContext {
    public constructor(private chartModel: ChartModel, private subChartModel?: SubChartModel) {}

    public getPropertyModule<K extends PropertyModuleName>(name: K): IChartProperty[K] | undefined {
        return this.chartModel.chartProperty?.[name];
    }

    public getChartModel() {
        return this.chartModel;
    }

    public getSubChartModel<SubChart = ISubChartModel>(): SubChart {
        return this.subChartModel as SubChart;
    }

    public bindSubChart(subChartModel: SubChartModel) {
        return new ChartContext(this.chartModel, subChartModel);
    }
}
